<template>
  <div>
    <topHeader :address="currentData.companyName"></topHeader>
    <div class="print-table-head">
      <div class="print-table-head__title">
        <!-- <div class="font-header">{{currentVendorQuoteData.year}}&nbsp;年第{{currentVendorQuoteData.period}}&nbsp;期面料报价明细表</div> -->
        <div class="font-header">
          {{ currentData.years }}&nbsp;年第{{
            currentData.periods
          }}&nbsp;期面料报价明细表
        </div>
      </div>
    </div>
    <div align="center" class="position">
      <table class="pageBreak styleTable">
        <tr align="left">
          <th colspan="19">
            供应商名称：{{
              currentData.vendorName || ''
            }}&nbsp;&nbsp;&nbsp;&nbsp;
          </th>
          <th colspan="12">
            报价日期：{{
              currentData.createdTime || ''
            }}
          </th>
        </tr>
        <tr>
          <th rowspan="3">面料组别</th>
          <th rowspan="3">面料名称</th>
          <th rowspan="3">供应商物料编号</th>
          <th rowspan="3">纱支规格/密度</th>
          <th rowspan="3">成份</th>
          <th rowspan="3"><font size="2">克重(针织/毛呢/牛仔)</font></th>
          <th rowspan="3">克重单位</th>
          <th rowspan="3">边到边幅宽(CM)</th>
          <th rowspan="3">实用幅宽(CM)</th>
          <th rowspan="3">横缩(-%)</th>
          <th rowspan="3">直缩(-%)</th>

          <th colspan="5" style="width: 10%">胚价</th>

          <th rowspan="3">染费（印花)</th>
          <th rowspan="3">损耗</th>
          <th rowspan="3">后整</th>
          <th rowspan="3">利润</th>

          <th rowspan="3">税点</th>

          <th rowspan="3">其他(运费,检测)</th>

          <th rowspan="3">颜色</th>
          <th rowspan="3">起订量</th>
          <th rowspan="3">价格单位</th>
          <th rowspan="3">
            数量级/色({{currentData.baseUnit ||  "" }})
          </th>
          <th rowspan="3">含税成品单价</th>
          <th rowspan="3">货期/天</th>

          <!-- <th rowspan="3">单位</th> -->
          <th rowspan="3" style="width: 10%">报价说明</th>
        </tr>
        <tr>
          <th rowspan="1">单位</th>
          <th colspan="2">白胚</th>
          <th colspan="2">色胚</th>
        </tr>
        <tr>
          <th></th>
          <th>原料</th>
          <th>织造</th>
          <th>原料</th>
          <th>织造</th>
        </tr>
        <template v-for="(info, index) in dataList">
          <tr height="30">
            <td rowspan="4">{{ info.developNo }}</td>
            <td rowspan="4">{{ info.developDesc }}</td>

            <td rowspan="4">{{ info.vendorMaterialCode }}</td>
            <td rowspan="4">{{ info.yarnDensity }}</td>
            <td rowspan="4">{{ info.composition }}</td>
            <td rowspan="4">{{ info.weight }}</td>

            <td rowspan="4">{{ info.weightUnit }}</td>

            <td rowspan="4">{{ info.edgeWidth }}</td>
            <td rowspan="4">{{ info.actEdgeWidth }}</td>
            <td rowspan="4">{{ info.horizShkPct }}</td>
            <td rowspan="4">{{ info.directShkPct }}</td>
            <!-- 单位 -->
            <td rowspan="4">{{ info.baseUnit }}</td>

            <td rowspan="4">{{ info.whiteRawPrice }}</td>
            <td rowspan="4">{{ info.whiteWeavePrice }}</td>
            <td rowspan="4">{{ info.colorRawPrice }}</td>
            <td rowspan="4">{{ info.colorWeavePrice }}</td>

            <td rowspan="4">{{ info.dyeingFee }}</td>
            <td rowspan="4">{{ info.lossRate }}</td>
            <td rowspan="4">{{ info.integralPrice }}</td>
            <td rowspan="4">{{ info.profitRate }}</td>

            <td rowspan="4">{{ info.taxRate }}</td>
            <td rowspan="4">{{ info.otherFee }}</td>

            <td rowspan="4">
              <font size="2">{{ info.colorDesc }}</font>
            </td>
            <td rowspan="4">{{ info.minOrderQty }}</td>
            <td rowspan="4">
              {{ info.priceUnit }}
            </td>
            <td>1000以下</td>
            <td>{{ info.price1 }}</td>
            <td>{{ info.deliveryDay1 }}</td>
            <!-- <td rowspan="4">米</td> -->
            <td rowspan="4" colspan="3">{{ info.quotedMemo }}</td>
          </tr>
          <tr height="30">
            <td>1000-3000</td>
            <td>{{ info.price2 }}</td>
            <td>{{ info.deliveryDay2 }}</td>
          </tr>
          <tr height="30">
            <td>3000-5000</td>
            <td>{{ info.price3 }}</td>
            <td>{{ info.deliveryDay3 }}</td>
          </tr>
          <tr height="30">
            <td>5000以上</td>
            <td>{{ info.price4 }}</td>
            <td>{{ info.deliveryDay4 }}</td>
          </tr>
        </template>
        <tr>
          <td style="border: 0">附注：</td>
          <td colspan="27" style="border: 0">
            1.以上报价均为含税价，报价期限由确认日期起半年内有效。
          </td>
        </tr>
        <tr>
          <td style="border: 0"></td>
          <td colspan="28" style="border: 0">
            2.以上所有项目必须填写，若无，则需说明原因，纱支规格填写顺序为：经纱规格*纬纱规格/经纱密度*纬纱密度。
          </td>
        </tr>
        <tr>
          <td style="border: 0"></td>
          <td colspan="28" style="border: 0">
            3.以上所报价货期资料，需与后期自评表内容一致(45天以上需特别注明），若前期不确定的规格需在表格上注明为预估数值。
          </td>
        </tr>
        <tr>
          <td style="border: 0"></td>
          <td colspan="28" style="border: 0">
            4.所有绣花水溶面料需在备注栏中填写生产机器及绣花针数。
          </td>
        </tr>
        <tr>
          <td style="border: 0"></td>
          <td colspan="28" style="border: 0">
            5.500米及针织300KG以上含检测费（特殊产品除外）。
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import topHeader from './head.vue'
export default {
  name: "table-head",
  components: {
    topHeader
  },
  created() {
    let idStr = this.$route.query.ids;
    let ids = idStr.split(",");
    this.$apis.autoAPi
      .POST_BPR_FABRIC_PRINT({
        ids,
        pageNumber: 1,
        pageSize: ids.length,
      })
      .done((res) => {
        this.dataList = res.data.records;
      })
      .fail((er) => {});
  },
  methods: {},
  data() {
    return {
      dataList: [],
      currentVendorQuoteData: {},
    };
  },
  computed: {
    currentData() {
      if(this.dataList.length) {
        return this.dataList[0]
      } else {
        return {}
      }
    }
  }
};
</script>

<style type="text/css">
table {
  border-collapse: collapse;
}
.styleTable tr th {
  border: 1px solid #000000;
  width: 3%;
}
.styleTable tr td {
  border: 1px solid #000000;
  width: 3%;
}
.font-header {
  font-size: 150%;
}
.position {
  position: relative;
  bottom: 50px;
}
.pageBreak {
  table-layout: fixed;
  page-break-after: always;
}
</style>
